export const BOT_CHAT_OPERATOR_USER_ID = 119;

/**
 * User được phép tạo thông báo trong nhóm chat BOT hệ thống.
 *
 * @param {number|string|null|undefined} userId
 * @returns {boolean}
 */
export function isBotChatOperator(userId) {
  return Number(userId) === BOT_CHAT_OPERATOR_USER_ID;
}

/**
 * Không cho soạn tin thường trong BOT (kể cả operator) — chỉ thông báo qua modal.
 *
 * @param {{ type?: string }|null|undefined} group
 * @param {number|string|null|undefined} userId
 * @returns {boolean}
 */
export function canComposeInBotChat() {
  return false;
}

/**
 * @param {{ type?: string }|null|undefined} group
 * @param {number|string|null|undefined} userId
 * @returns {boolean}
 */
export function canCreateBotAnnouncementInBotChat(group, userId) {
  if (!group || group.type !== 'BOT') {
    return false;
  }

  return isBotChatOperator(userId);
}
